import { z } from 'zod'

export const schema = z.object({
  name: z.string().min(1),
})
export type FormValues = z.infer<typeof schema>
export const FORM_ID = 'edit-sales-editor-template-form'
